import { render, staticRenderFns } from "./ShortagesAccount.vue?vue&type=template&id=787e9266&"
import script from "./ShortagesAccount.vue?vue&type=script&lang=js&"
export * from "./ShortagesAccount.vue?vue&type=script&lang=js&"
import style0 from "./ShortagesAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports